
export default {
    getContrato(state) {
        return state.contrato
    },
    getContratos(state) {
        return state.contratos
    },
}